<template>
  <DialogBase
    title="Thêm nhóm"
    :visible.sync="dialogVisible"
    size="sm"
    panel-icon="el-icon-circle-plus-outline"
    panel-icon-tone="success"
    panel-title="Thêm nhóm"
    panel-subtitle="Chọn nhóm để thêm học sinh vào"
    :confirm-loading="loadingAddToGroup"
    :confirm-disabled="listGroupSelect.length === 0"
    confirm-text="Xác nhận"
    confirm-type="primary"
    cancel-text="Hủy"
    cancel-type=""
    cancel-icon=""
    confirm-icon=""
    @before-close="handleClose"
    @cancel="handleClose"
    @confirm="handleAddToGroup"
    @open="handleOpen"
  >
    <el-form
      ref="dataForm"
      label-position="top"
    >
      <el-form-item label="Chọn thêm nhóm">
        <el-select
          v-model="listGroupSelect"
          multiple
          placeholder="Chọn nhóm"
          class="sk-u-w-full"
        >
          <el-option
            v-for="(item, index) in listGroup"
            :key="index"
            :label="item.nameGroup"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
    </el-form>
  </DialogBase>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import { mapState } from "vuex";
import StudentGroupService from "@/services/Finance_Kids_V2/StudentGroupService";

export default {
  components: { DialogBase },
  computed: {
    ...mapState("studentGroupModule", ["idKidList", "dataSearch"]),
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadingAddToGroup: false,
      listGroup: [],
      listGroupSelect: [],
      studentsParam: {
        idKidList: [],
        idGroupList: [],
      },
    };
  },
  methods: {
    handleOpen() {
      StudentGroupService.getListKidsGroup().then((response) => {
        this.listGroup = response.data;
      });
    },

    handleAddToGroup() {
      this.loadingAddToGroup = true;
      this.studentsParam.idKidList = this.idKidList
        .split(",")
        .map((id) => parseInt(id.trim(), 10));
      this.studentsParam.idGroupList = this.listGroupSelect;
      StudentGroupService.addMultipleStudentInGroup(this.studentsParam).then(
        () => {
          this.$message({
            type: "success",
            message: "Thêm thành công",
          });
          this.loadingAddToGroup = false;
          this.handleClose();
        }
      );
    },

    handleClose(done) {
      this.loadingAddToGroup = false;
      this.$store.dispatch(
        "studentGroupModule/filter_students_group",
        this.dataSearch
      );
      this.listGroupSelect = [];
      this.$emit("dialog-close", false);
      if (typeof done === "function") done();
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog";
</style>